export default {
  getUser: function (state) {
        return state.curuser
    },
    count:function (state){
        return state.goodsCarList.reduce((p,g)=>p+g.car_num ,0)
    }

}



// WEBPACK FOOTER //
// ./src/store/getters.js